import styled from "styled-components/native"

export const Image = styled.Image`
    border-radius: 100%;
`